<template>
  <div style="height: 100vh;background-color: #f4f4f4" v-if="chatSessionId">
    <div v-if="messages && messages.length" id="list" class="list" :class="fileList.length ? 'list-img' : ''">
      <template v-for="(item, index) in messages">
        <div :key="index" :class="item.role" v-if="item.show">
          <div class="role">
            <van-icon class="icon-user" v-if="item.role == 'user'" name="contact" size="38px" color="white"/>
            <img v-else src="@/assets/images/assistant.png" alt="">
          </div>
          <div class="content">
            <div class="content-box">
              <template v-if="item.file && item.file.length">
                <div class="content-img" v-for="(it, id) in item.file" :key="id" @click="showImg(it)">
                  <div class="icon">
                    <van-icon name="description-o" size="34" />
                  </div>
                  <div class="img-desc">
                    <p>名称：{{it.origin_name}}</p>
                    <p>类型：{{it.mime_type | FileName}}</p>
                    <p>大小：{{it.size | FileSize}}</p>
                  </div>
                </div>
              </template>
              <div :id="item.id" class="content-p" v-html="markdownToHtml(item.content)"></div>
              <div v-if="item.role == 'assistant'">
                <div class="AI-tag-box">
                  <div class="AI-tags">
                    <span class="good-job-tag" @click="setTag(index, item.goodJob, 1)">
                      <van-icon size="24" :name="item.goodJob == 1 ? 'good-job' : 'good-job-o'" class="good" :class="item.goodJob == 1 ? 'active' : ''" />
                    </span>
                    <span class="good-job-tag" @click="setTag(index, item.goodJob, 2)">
                      <van-icon size="24" :name="item.goodJob == 2 ? 'good-job' : 'good-job-o'" class="bad" :class="item.goodJob == 2 ? 'active' : ''" />
                    </span>
                  </div>
                  <span class="ai">
                    -- AI生成
                  </span>
                </div>
              </div>
            </div>
            <div @click="reSend(item)" :class="isLoading ? 'fail-load': ''" class="fail" v-if="!item.status && index + 1 == messages.length">
              <van-loading v-if="isLoading" color="#fff" vertical class="icon-replay" />
              <van-icon v-else class="icon" name="fail" size="18px"/>
            </div>
          </div>
        </div>
      </template>
      <van-divider
        :style="{ borderColor: '#999', padding: '0 20px', margin: '5px 0' }"
        v-show="isLoading && !messages[messages.length - 1].show">
        {{textList[textIndex]}}
      </van-divider>
    </div>
    <div v-else class="start" :class="fileList.length ? 'start-img' : ''">
      <img src="@/assets/images/assistant.png" alt="">
      <p>您好，我是养旺健康助手，请问我可以帮您点什么呢？</p>
    </div>
    <div class="input-img-box">
      <div class="swipe" v-show="fileList.length">
        <van-swipe class="file-swipe" :loop="false" :show-indicators="false" :width="200">
          <van-swipe-item class="swipe-item" v-for="(item, index) in fileList" :key="index">
            <div class="item-box">
              <!-- <div class="icon">
                <van-icon name="description-o" size="34" />
              </div> -->
              <div class="img-item">
                <img :src="item.DataUrl" alt="" @click="previewImg([item.DataUrl], 0)">
              </div>
              <div class="desc">
                <p class="name txt-elips">{{item.origin_name}}</p>
                <p class="detail txt-elips">
                  <span>{{item.mime_type | FileName}}</span>
                  <span>&nbsp;</span>
                  <span>{{ item.size | FileSize }}</span>
                </p>
              </div>
            </div>
            <van-icon name="cross" class="item-del" @click="del(item, index)"/>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="input-box">
        <div class="my-input pos-r">
          <input placeholder="和 养旺健康助手 聊天" name='value' :disabled="isLoading" class="input" type="text" v-model="value" :maxlength="150" @keypress.enter="send()">
          <span class="num">{{ value.length }}/150</span>
        </div>
        <button :disabled="isLoading" class="reset" type="primary" @click="reset()">
          <van-icon name="replay" size="22px" />
        </button>
        <!-- <div class="update-box" @click="ClickBox">
          <input ref="update" @click="updateClick" class="update-input" type="file" accept="image/*" name="file" @change="update">
          <van-icon class="update" name="link-o" size="22px" />
        </div> -->
        <!-- <div class="update-box" @click="uploadImg()">
          <input ref="update" @click="updateClick" class="update-input" type="file" accept="image/*" name="file" @change="update">
          <van-icon class="update2" name="link-o" size="22px" />
        </div> -->
        <van-button icon="play" type="primary" :disabled="isLoading" class="send" @click="send()" />
      </div>
    </div>
    <van-popup
      v-model="showPop" round position="bottom"
      close-icon="close" :closeable="true" :close-on-click-overlay="false"
      @closed="closePop" :style="{ height: '300px' }">
      <div class="pop">
        <p class="title">反馈</p>
        <div class="chat-tags" v-show="tags.length">
          <p>
            <span v-for="(it, index) in tags" @click="tag == it.value ? (tag = '') : (tag = it.value);" :key="index" class="chat-tag" :class="tag == it.value ? 'active' : ''">{{ it.label }}</span>
          </p>
        </div>
        <van-field
          class="textarea"
          v-model="description"
          rows="3" size="large"
          type="textarea" maxlength="150" show-word-limit
          placeholder="我们想知道你对此回答不满意的原因，你认为更好的回答是什么?"
        />
        <van-button type="info" class="tag-send" @click="tagApi(index, 2)">提交</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { uploadFile } from '@/api/retry';
import markdownIt from 'markdown-it';
import Compressor from 'compressorjs';
let md = '';
export default {
  name: 'ai',
  data() {
    return {
      textList: [
        '旺旺正在翻阅资料，查询参考文档 ···',
        '旺旺正在努力思考中，请稍后 ···',
        '旺旺没有偷懒，旺旺有在努力哦！'
      ],
      textIndex: 0,
      value: '',
      fileList: [],
      showPop: false,
      index: -1,
      tags: [],
      tag: '',
      description: ''
    };
  },
  filters: {
    FileName: function (value) {
      if (!value) {
        return '';
      }
      const list = value.split('/');
      return list[list.length - 1];
    },
    FileSize: function (value) {
      if (!value) {
        return '0 Bytes';
      }
      const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      let i = 0;
      while (value >= 1024) {
        value /= 1024;
        i++;
      }
      return value.toFixed(2) + ' ' + units[i];
    }
  },
  watch: {
    chatSessionId() {
      this.$nextTick(() => {
        this.init();
      });
    }
  },
  computed: {
    deviceId() {
      return this.$route.query.deviceId || '';
    },
    ...mapState({
      messages: state => state.chatStore.messages,
      chatSessionId: state => state.chatStore.chatSessionId,
      isLoading: state => state.chatStore.isLoading,
      error: state => state.chatStore.error
    })
  },
  beforeMount() {
    md = markdownIt({
      html: true,
      xhtmlOut: true,
      linkify: false,
      tyographer: false
    });
    this.getSession();
    // 获取固定对话id 内存ID > app应用ID > 自生成ID
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    md = undefined;
    this.$store.dispatch('chatStore/setState', {});
  },
  methods: {
    markdownToHtml(value) {
      return md.render(value);
    },
    generateId() {
      return Date.now().toString(36) + Math.random().toString(36).substr(2);
    },
    init() {
      this.getEnums();
      const divElement = document.getElementById('list');
      if (divElement) {
        const domList = Array.from(divElement.getElementsByTagName('table'));
        domList.forEach(item => {
          const newParent = document.createElement('div');
          newParent.className = 'tableDiv';
          item.parentNode.insertBefore(newParent, item.nextElementSibling);
          newParent.appendChild(item);
        });
        divElement.scrollTo(0, divElement.scrollHeight);
      }
    },
    async getEnums() {
      try {
        const res = await this.$store.dispatch('getData', {
          url: '/api/http/chat/enums'
        });
        this.tags = res.data ? (res.data.feedback_tags ? (res.data.feedback_tags.items ? res.data.feedback_tags.items : []) : []) : [];
      } catch (error) {
        this.ToastUni(error.message);
      }
    },
    async showImg(img) {
      try {
        this.Loading();
        const res = await this.$store.dispatch('postData', {
          url: '/api/http/chat/file/preview',
          data: {
            // eslint-disable-next-line
            data_encrypt: img.data_encrypt
          }
        });
        this.ToastClear();
        this.previewImg([res.url], 0);
      } catch (error) {
        this.ToastClear();
        console.log(error);
        this.ToastUni('预览失败:' + error.message);
      }
    },
    ClickBox() {
      this.$refs.update.click();
    },
    updateClick(event) {
      if (this.isLoading || this.fileList.length >= 1) {
        event.preventDefault();
      }
      if (this.fileList.length >= 1) {
        this.ToastUni('最多上传1张');
      }
    },
    async update(event) {
      try {
        const files = event.target.files;
        if (files && files.length) {
          const file = files[0];
          const name = file.name;
          if (name.length > 200) {
            this.ToastUni('文件名不得超过200字符！');
            return;
          }
          // const fileType = file.type;
          const maxSize = 10485760; // 最大文件大小限制为10MB（10 * 1024 * 1024字节）
          const CompressorFile = await new Promise((resolve, reject) => {
            // compressorjs 默认开启 checkOrientation 选项
            // 会将图片修正为正确方向
            // eslint-disable-next-line
            new Compressor(file, {
              checkOrientation: !(file.size > maxSize), // 处理 >10MB 图片时禁用 checkOrientation 防止内存溢出
              quality: 0.7, // 压缩质量（0–1）
              maxWidth: 1200, // 最大宽度
              success: newFile => {
                const fileSize = newFile.size; // 获取文件大小（字节）
                if (fileSize > maxSize) {
                  this.ToastUni('文件压缩后大小不能超过10MB！');
                  reject(new Error('文件压缩后大小不能超过10MB！'));
                } else {
                  resolve(newFile);
                }
              },
              error: err => {
                this.$toast.clear();
                reject(err);
              }
            });
          });
          const formData = new FormData();
          formData.append('chat_session_id', this.chatSessionId);
          formData.append('file', CompressorFile);
          this.Loading(`正在上传...`);
          const res = await uploadFile(formData, '/api/http/chat/upload');
          const item = res.data;
          const that = this;
          const reader = new FileReader();
          reader.onload = function(event) {
            item.DataUrl = event.target.result;
            that.fileList.push(item);
          };
          reader.readAsDataURL(file); // 读取文件内容并转换为DataURL
          this.ToastClear();
        }
      } catch (error) {
        this.ToastClear();
        this.ToastUni('上传失败:' + error.message);
      }
    },
    async uploadImg() {
      if (this.fileList.length) {
        return;
      }
      try {
        const data = {
          url: '/api/http/chat/upload', // 上传地址
          max: 1,
          maxSize: 10485760, // 最大文件大小，最大文件大小限制为5MB（5 * 1024 * 1024字节）
          data: {
            // eslint-disable-next-line
            chat_session_id: this.chatSessionId
          }, // 除file对象外formData所需对象<键值对>
          fileField: 'file', // file对象所属字段名
          success: 'aiUploadImage', // 确认回调方法名success(list[res<upload接口返回对象>])
          error: 'Toast' // 失败回调方法名error(msg<报错信息字符串>)
        };
        const json = await this.uploadImage(data);
        json.map(res => {
          const item = res.data;
          item.showPop = false;
          this.fileList.push(item);
        });
      } catch (error) {
        console.log(error);
        if (error.message) {
          this.ToastUni('上传失败:' + error.message);
        }
      }
    },
    del(item, index) {
      this.fileList.splice(index, 1);
    },
    async getSession() {
      try {
        this.Loading();
        await this.$store.dispatch('chatStore/getState', {});
        const res = await this.$store.dispatch('postData', {
          url: '/api/http/chat/session'
        });
        if (res && res.data_encrypt) {
          const Id = res.data_encrypt;
          if (Id !== this.chatSessionId) {
            this.$store.commit('chatStore/setError', null);
            this.$store.commit('chatStore/setIsLoading', false);
            this.$store.commit('chatStore/clearMessages');
            this.$store.commit('chatStore/updateChatSessionId', Id);
          }
        }
        this.ToastClear();
      } catch (error) {
        this.ToastClear();
        console.log(error);
        this.ToastUni(error.message || error.msg || error);
      }
    },
    async reset() {
      this.Dialog({
        title: '是否重置对话？',
        message: ''
      })
        .then(async () => {
          try {
            this.Loading();
            const res = await this.$store.dispatch('postData', {
              url: '/api/http/chat/session/reset'
            });
            if (res && res.data_encrypt) {
              const Id = res.data_encrypt;
              this.$store.commit('chatStore/setError', null);
              this.$store.commit('chatStore/setIsLoading', false);
              this.$store.commit('chatStore/clearMessages');
              this.$store.commit('chatStore/updateChatSessionId', Id);
              this.ToastUni('重置成功');
            }
            this.ToastClear();
          } catch (error) {
            this.ToastClear();
            this.ToastUni(error.message || error.msg || error);
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    async sendMsg(content, file = '', messageId = '') {
      function scrollToBottom() {
        const divElement = document.getElementById('list');
        if (divElement) {
          divElement.scrollTo(0, divElement.scrollHeight);
        }
      }
      let index = '';
      try {
        if (this.isLoading) {
          return;
        }
        if (!content) {
          this.ToastUni('请输入对话内容!');
          return;
        }
        const userMessageId = this.generateId();
        if (messageId) {
          this.$store.commit('chatStore/reSendUserMessage', { id: messageId, newId: userMessageId });
        } else {
          const userMessage = {
            id: userMessageId,
            code: '',
            content: content,
            file: file,
            role: 'user',
            timestamp: Date.now(),
            show: true,
            status: false
          };
          this.$store.commit('chatStore/addMessage', userMessage);
          this.$nextTick(() => {
            scrollToBottom();
          });
        }
        this.$store.commit('chatStore/setIsLoading', true);
        this.$store.commit('chatStore/setError', null);
        // await sleep(1500);
        const assistantMessageId = this.generateId();
        const assistantMessage = {
          id: assistantMessageId,
          code: '',
          content: '',
          file: '',
          role: 'assistant',
          timestamp: Date.now(),
          show: false,
          status: false,
          goodJob: 0
        };
        let currentContent = '';
        this.$store.commit('chatStore/addMessage', assistantMessage);
        const that = this;
        const data = {
          // eslint-disable-next-line
          chat_session_id: this.chatSessionId,
          prompt: content
        };
        if (file) {
          // eslint-disable-next-line
          data.ref_file = file.map(i => {
            return i.data_encrypt;
          });
        }
        this.textIndex = 0;
        this.$store.dispatch('chatStore/sendMessage', {
          url: '/api/http/chat/completion',
          data: data,
          onMessage(sseMessage, first) {
            if (first) {
              clearInterval(index);
            }
            if (sseMessage.choices && sseMessage.choices[0].delta.content) {
              const newContent = sseMessage.choices[0].delta.content;
              currentContent += newContent;
              that.$store.commit('chatStore/updateAssistantMessage', { id: assistantMessageId, content: currentContent });
              that.$nextTick(() => {
                scrollToBottom();
              });
            }
          },
          onError(error) {
            clearInterval(index);
            that.$store.commit('chatStore/setError', error.message);
            that.$store.commit('chatStore/setIsLoading', false);
            that.$store.commit('chatStore/updateAssistantMessage', { id: assistantMessageId, content: '', status: false, show: false });
            that.$store.commit('chatStore/updateUserMessage', { id: userMessageId, content: content, status: false });
            that.$store.dispatch('chatStore/setState', {});
            that.ToastUni('发送失败:' + error.message);
            console.log('onError:', error);
          },
          onComplete({ reason, headers }) {
            clearInterval(index);
            const code = headers.get('message-id');
            that.$store.commit('chatStore/updateChat', { userId: userMessageId, assistantId: assistantMessageId, code: code });
            switch (reason) {
              case 'content_filter':
                that.$store.commit('chatStore/updateAssistantMessage', { id: assistantMessageId, content: '哎呀，我们换个话题聊聊吧~' });
                that.$nextTick(() => {
                  scrollToBottom();
                });
                break;
              case 'stop':
              default:
                that.$nextTick(() => {
                  const div = document.getElementById(assistantMessageId);
                  if (div) {
                    if (!div.getElementsByClassName('tableDiv').length) {
                      const domList = Array.from(div.getElementsByTagName('table'));
                      domList.forEach(item => {
                        const newParent = document.createElement('div');
                        newParent.className = 'tableDiv';
                        item.parentNode.insertBefore(newParent, item.nextElementSibling);
                        newParent.appendChild(item);
                      });
                    }
                  }
                  scrollToBottom();
                });
                break;
            }
            that.$store.commit('chatStore/setIsLoading', false);
            that.$store.dispatch('chatStore/setState', {});
          }
        });
        index = setInterval(() => {
          that.textIndex = (new Date()).getTime() % that.textList.length;
        }, 1500);
      } catch (error) {
        clearInterval(index);
        // console.log(error);
        // todo
      }
    },
    async reSend(msg) {
      if (!msg.content) {
        this.ToastUni('无对话内容!');
        return;
      }
      try {
        await this.sendMsg(msg.content, msg.file, msg.id);
      } catch (error) {
        console.log(error);
        this.ToastUni('发送消息失败' + error.message);
        // todo
      }
    },
    async send() {
      if (!this.value.trim()) {
        this.ToastUni('请输入对话内容!');
        return;
      }
      try {
        const list = this.fileList.map(img => {
          return {
            // eslint-disable-next-line
            origin_name: img.origin_name,
            // eslint-disable-next-line
            mime_type: img.mime_type,
            size: img.size,
            // eslint-disable-next-line
            data_encrypt: img.data_encrypt
          };
        });
        const file = this.fileList.length ? JSON.parse(JSON.stringify(list)) : '';
        await this.sendMsg(this.value.trim(), file);
        this.fileList = [];
        this.value = '';
      } catch (error) {
        console.log(error);
        this.ToastUni('消息发送失败:' + error.message);
        // todo
      }
    },
    async setTag(index, oldType, newType) {
      if (!oldType) {
        if (newType === 2) {
          this.showPop = true;
          this.index = index;
        } else {
          await this.tagApi(index, newType);
        }
      } else {
        if (oldType === newType) {
          await this.tagApi(index, 0);
        } else {
          if (newType === 2) {
            this.showPop = true;
            this.index = index;
          } else {
            await this.tagApi(index, newType);
          }
        }
      }
    },
    async tagApi(index, type) {
      try {
        this.Loading();
        await this.$store.dispatch('postData', {
          url: '/api/http/chat/message_feedback',
          data: {
            // eslint-disable-next-line
            chat_session_id: this.chatSessionId,
            MessageId: this.messages[index].code,
            Description: this.description,
            FeedbackType: type,
            FeedbackTag: this.tag
          }
        });
        this.$store.dispatch('chatStore/updateChatTag', { index: index, type: type });
        if (this.showPop) {
          this.$nextTick(() => {
            this.showPop = false;
          });
        }
        this.ToastClear();
      } catch (error) {
        this.ToastClear();
        console.log(error);
        this.ToastUni(error.message);
      }
    },
    closePop() {
      this.$nextTick(() => {
        this.description = '';
        this.index = -1;
        this.tag = '';
      });
    }
  }
};
</script>

<style lang="less" scoped>
.list{
  width: 100vw;
  height: calc(100vh - 56px);
  padding-bottom: 15px;
  box-sizing: border-box;
  overflow-y: auto;
  .user,.assistant{
    padding: 5px;
    margin: 5px 0 0 0;
    box-sizing: border-box;
  }
  .user {
    display: flex;
    flex-direction: row-reverse;
    .role{
      background-color: #B2DDFF;
    }
    .content{
      flex-direction: row-reverse;
      .content-box{
        background-color: #e1effe;
      }
    }
  }
  .assistant{
    display: flex;
    flex-direction: row;
    .role{
      background-color: #FFF;
    }
    .content{
      flex-direction: row;
      .content-box{
        background-color: #fff;
      }
    }
  }
  .role{
    width: 40px;
    height: 40px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 50%;
    margin: 0 5px;
    overflow-y: hidden;
    img{
      border-radius: 50%;
      width: 40px;
      height: 40px;
      display: block;
    }
    .icon-user{
      transform: translateY(6px);
    }
  }
  .content{
    width: calc(100% - 50px);
    display: flex;
    align-items: flex-end;
    height: auto;
  }
  .content-box{
    padding: 10px;
    border-radius: 10px;
    max-width: calc(100% - 65px);
    .content-img{
      background-color: #fff;
      padding: 8px;
      border-radius: 8px;
      margin: 0 0 5px 0;
      max-width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      .icon{
        width: 50px;
        height: 50px;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ccc;
      }
      .img-desc{
        max-width: calc(100% - 60px);
        p{
          font-size: 12px;
          width: 100%;
          overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-wrap:normal
        }
      }
    }
    .content-p{
      height: auto;
      width: 100%;
      // text-align: justify;
      // text-align-last: left; /* 仅影响最后一行 */
    }
    .AI-tag-box{
      margin: 2px 0;
      display: flex;
      height: 34px;
      background-color: #fdfdfd;
      border-radius: 5px;
      align-items: center;
      justify-content: space-between;
      .tags{
        margin-left: 2px;
      }
      .good-job-tag{
        display: inline-block;
        padding: 3px;
        box-sizing: border-box;
        height: 30px;
        width: 30px;
        color: #333;
        border-radius: 50%;
        margin: 0 2px;
      }
      .good-job-tag:hover{
        cursor: pointer;
        filter: drop-shadow(-1px -1px 2px #666);
      }
      .good{
        transform: translateY(-1px);
      }
      .good.active{
        filter: drop-shadow(-1px -1px 2px #333);
        color: #cc9;
      }
      .bad{
        transform: rotate(180deg)translateY(-1px);
      }
      .bad.active{
        filter: drop-shadow(-1px -1px 2px #333);
        color: #6c9;
      }
      .ai{
        padding-right: 7px;
        font-size: 13px;
        color: #333;
      }
    }
  }
  .content-p /deep/ .tableDiv{
    width: calc(100vw - 130px);
    padding: 10px 0;
    // width: 100%;
    overflow-x: auto;
    table{
      min-width: 100%;
      width: max-content;
      border: 1px solid #333;
      border-radius: 5px;
      th{
        padding: 2px 4px;
      }
      th+th{
        border-left: 1px solid #333;
      }
      td{
        padding: 2px 4px;
      }
      td+td{
        border-left: 1px solid #333;
      }
    }
  }
  .fail{
    position: relative;
    width: 20px;
    height: 20px;
    box-sizing: border-box;
    margin: 6px;
    border-radius: 50%;
    background-color:red;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .fail-load{
    background-color:#4bdbff;
  }
  .fail .icon-replay{
    width: 14px;
    height: 14px;
  }
}
.list-img{
  height: calc(100vh - 140px);
}
.start{
  width: 100vw;
  height: calc(100vh - 56px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    border-radius: 10%;
    width: 60px;
    height: 60px;
    display: block;
  }
  p{
    margin-top: 20px;
    max-width: 80vw;
    text-align: center;
  }
}
.start-img{
  height: calc(100vh - 140px);
}
.input-img-box{
  background-color: #fff;
  border-radius: 15px 15px 0 0;
  .swipe{
    height: 80px;
    .swipe-item{
      position: relative;
      box-sizing: border-box;
      width: 200px;
      height: 80px;
      padding: 5px 10px;
      .item-box{
        margin: 5px 0;
        border: 1px solid rgba(0,0,0,.1);
        border-radius: 10px;
        display: flex;
        flex-direction: row;
        .img-item{
          position: relative;
          width: 60px;
          height: 60px;
          margin-right: 10px;
          img{
            width: 50px;
            height: 50px;
            margin: 5px;
            object-fit: cover;
            border-radius: 5px;
          }
        }
        .icon{
          width: 60px;
          height: 60px;
          color: #ccc;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .desc{
          padding: 10px 0;
          width: 100px;
          line-height: 20px;
          .name{
            font-size: 14px;
            color: #000;
          }
          .detail{
            font-size: 14px;
            color: #ccc;
          }
        }
      }
      .item-del{
        box-sizing: border-box;
        position: absolute;
        top: 6px;
        right: 6px;
        width: 20px;
        height: 20px;
        padding: 2px;
        font-size: 14px;
        background-color: #fff;
        border-radius: 50%;
        border: 1px solid #ccc;
      }
    }
  }
}
.input-box{
  background-color: #fff;
  width: 100vw;
  height: 56px;
  padding: 8px;
  line-height: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    border: 0;
    margin: 0 5px;
    padding: 0;
    line-height: 40px;
    width: 22px;
    height: 40px;
  }
  .my-input{
    width: calc(100% - 85px);
    // width: calc(100% - 110px);
    box-sizing: border-box;
  }
  .input{
    width: 100%;
    border: 0;
    background-color: #f4f4f4;
    border-radius: 10px;
    padding: 0 55px 0 8px;
    box-sizing: border-box;
  }
  .num{
    position: absolute;
    right: 5px;
    font-size: 12px;
    color: #666;
  }
  .reset{
    background-color: #00000000;
  }
  .reset:hover{
    cursor: pointer;
  }
  .update-box{
    position: relative;
    margin: 0 5px;
    .update2{
      z-index: 2;
      background-color: #fff;
      width: 22px;
      height: 40px;
      line-height: 40px;
    }
  }
  .update-box:hover{
    cursor: pointer;
  }
  .update{
    background-color: #fff;
    width: 22px;
    height: 40px;
    line-height: 40px;
    pointer-events: none;
  }
  .update-input{
    display: none;
  }
  .send{
    position: relative;
    border-radius: 5px;
    width: 30px;
    height: 30px;
    font-size: 24px;
    padding: 0;
    background-color: rgb(28, 100, 242);
  }
  .send /deep/ .van-icon{
    transform: rotateX(45deg);
  }
  .send::after{
    content: '';
    position: absolute;
    top: 15px;
    left: 0px;
    width: 15px;
    height: 1px;
    background-color: rgb(28, 100, 242)
  }
}
.pop{
  height: 100%;
  widows: 100%;
  box-sizing: border-box;
  padding: 10px 14px 14px 14px;
  .title{
    line-height: 30px;
    font-weight: 600;
    text-align: center;
  }
  .chat-tags{
    padding: 10px 0 8px;
    height: 35px;
    width: 100%;
    overflow-x: auto;
    box-sizing: content-box;
    p{
      line-height: 35px;
      width: max-content;
    }
    .chat-tag~.chat-tag{
      margin-left: 10px;
    }
    .chat-tag{
      border: 1px solid #e3e3e3;
      color: #363636;
      border-radius: 8px;
      padding: 6px;
    }
    .chat-tag.active{
      border: 1px solid #abe6e6;
      color: #fff;
      background-color: #1989fa;
    }
  }
  .textarea{
    margin-top: 3px;
    border-radius: 10px;
    background: #e9e9e9;
    font-size: 18px;
    line-height: 26px;
  }
  .tag-send{
    margin: 15px 0;
    width: 100%;
    text-align: center;
    border-radius: 22px;
  }
}
</style>
